// use the default but overrite the info
import {
  MenuComponent,
  acceptSuggestionsInRange,
  rejectSuggestionsInRange,
  CommandHandler,
} from 'prosemirror-suggestion-mode';

// Create a custom component for displaying suggestion reason in the hover menu
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createSuggestionReasonComponent = (attrs: Record<string, any>): MenuComponent => {
  const reasonDiv = document.createElement('div');
  reasonDiv.className = 'suggestion-reason';
  const reason = attrs?.data?.reason;
  if (reason) {
    const reasonText = document.createElement('span');
    reasonText.textContent = reason;
    reasonText.className = 'reason-content';
    reasonDiv.appendChild(reasonText);
  }

  return { dom: reasonDiv };
};

export const createButtonsComponent = (from: number, to: number, handler: CommandHandler): MenuComponent => {
  const buttonsDiv = document.createElement('div');
  buttonsDiv.className = 'suggestion-buttons';

  const acceptButton = document.createElement('button');
  acceptButton.className = 'suggestion-accept';
  acceptButton.textContent = 'A';
  acceptButton.addEventListener('click', (e) => {
    e.stopPropagation();
    handler.dispatch(acceptSuggestionsInRange(from, to));
  });

  const rejectButton = document.createElement('button');
  rejectButton.className = 'suggestion-reject';
  rejectButton.textContent = 'R';
  rejectButton.addEventListener('click', (e) => {
    e.stopPropagation();
    handler.dispatch(rejectSuggestionsInRange(from, to));
  });

  // Hacky function to just make the icons from path data - this is the core lib and there's no other icons
  // so haven't built out a system for them
  const makeIconFromPath = (pathData: string[]): SVGSVGElement => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '12');
    svg.setAttribute('height', '12');
    svg.setAttribute('viewBox', '0 0 8 8');
    svg.setAttribute('fill', 'none');
    svg.innerHTML = pathData
      .map((path) => `<path d="${path}" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>`)
      .join('');
    return svg;
  };

  // Use the helper function
  const acceptIcon = makeIconFromPath(['M6.5 2L3.5 5L1.5 3']);

  const rejectIcon = makeIconFromPath(['M2 2L6 6', 'M6 2L2 6']);

  acceptButton.innerHTML = '';
  acceptButton.appendChild(acceptIcon);

  rejectButton.innerHTML = '';
  rejectButton.appendChild(rejectIcon);

  buttonsDiv.appendChild(acceptButton);
  buttonsDiv.appendChild(rejectButton);

  return { dom: buttonsDiv };
};
